export const CenterMessagesReadme = {
  tool: [
    "The Center Messages tool allows you to set messages to be shown to the PA while in a session with a guest.",
    "A center message is a message with specific text that is shown to the PA within the dynamic content pane when they are in a session that matches the set Center and timeline.",
    "In this tool, you can search through the existing center messages, update those that have not ended, and create new ones.",
    "You can also preview how the message will appear to a PA in a specific center at some date in the past or future.",
    "Center Messages may not be reassigned to a different set of centers. Only the timeline or message shown may be changed.",
    "Center Messages which have expired may no longer be updated."
  ],
  queryMessagesTimespan: [
    "Set the time span for which you would like to view the active messages.",
    "Select a specific center and message to load it in the editor and view its information in greater detail.",
    "When creating a new center message, you may select as many Centers as you wish to link to the new message."
  ],
  validDuration: [
    "A center message will only be shown to the user for a specified length of time.",
    "A start date is required. You may edit the start date of a center message only if the message hasn't gone live yet.",
    "An end date is not required. You may only edit the end date of a center message if the message hasn't expired."
  ],
  title: [
    "This title will be shown at the top of the message. It does NOT support markdown.",
    "If an end date has been set for the message, it will appear after the title.",
    "Ex: My Title - Ends: April 1, 2021"
  ],
  message: [
    "The message typed here will be shown to the PA. A preview of this message will be updated live in the right column.",
    "The message supports markdown syntax. For documentation on how to use markdown syntax, please go to:",
    "https://www.markdownguide.org/basic-syntax/",
    "Here are examples of the most commonly used markdown syntax:",
    "# This is a big Header",
    "## This is a medium Header",
    "### This is a small Header",
    "*This text is in italics.*",
    "**This text is bolded.**",
    '[This is a web link](https://www.google.com "This is a hover tooltip.")',
    "- These",
    "- Are",
    "- Bullets"
  ],
  preview: [
    "Shown below is the preview of the message that the user will experience when they are in a session.",
    "Select a center in the first column, and specified the desired time for the preview to mimic."
  ]
};
